export const servers = [
  "https://hub.kanda.co.uk",
  "https://hub-qa.kanda.co.uk",
  "http://localhost:8080",
];
